import React, { useState, useEffect } from 'react';
import S from './style';
import Title from '../Title';
import Button from '../Button';
import { bool, func, node, string } from 'prop-types';

function Popup({
  open,
  title,
  body,
  cancelLabel,
  confirmLabel,
  onCancel,
  onConfirm,
  disabledConfirm = false,
}) {
  const [showAnimation, setShowAnimation] = useState(false);

  useEffect(() => {
    if (open) setShowAnimation(true);
  }, [open]);

  const handleCancel = () => {
    setShowAnimation(false);
    setTimeout(() => {
      onCancel();
    }, 300);
  };

  const handleConfirm = () => {
    setShowAnimation(false);
    setTimeout(() => {
      onConfirm();
    }, 300);
  };

  if (!open) return null;

  return (
    <S.Overlay show={showAnimation}>
      <S.Dialog show={showAnimation}>
        <S.Close onClick={handleCancel}>
          <S.XIcon />
        </S.Close>

        {title ? <Title>{title}</Title> : null}

        <S.Content>{body}</S.Content>

        {cancelLabel || confirmLabel ? (
          <S.Actions>
            {cancelLabel && onCancel ? (
              <Button type="button" secondary onClick={handleCancel}>
                {cancelLabel}
              </Button>
            ) : null}
            {confirmLabel &&
              (onConfirm ? (
                <Button
                  type="submit"
                  onClick={handleConfirm}
                  disabled={disabledConfirm}
                >
                  {confirmLabel}
                </Button>
              ) : (
                <Button type="submit" disabled={disabledConfirm}>
                  {confirmLabel}
                </Button>
              ))}
          </S.Actions>
        ) : null}
      </S.Dialog>
    </S.Overlay>
  );
}

Popup.propTypes = {
  open: bool,
  title: string,
  body: node.isRequired,
  cancelLabel: string,
  confirmLabel: string,
  onCancel: func,
  onConfirm: func,
  disabledConfirm: bool,
};

Popup.defaultProps = {
  open: false,
  title: null,
  cancelLabel: null,
  confirmLabel: null,
  onCancel: null,
  onConfirm: null,
  disabledConfirm: false,
};

export default Popup;
